import { MailboxInfo } from 'owa-client-ids';
import { addPopoutV2, getReadingPaneRouteForPopoutV2 } from 'owa-popout-v2';
import ReadingPanePopoutItemFolderInfo from '../schema/ReadingPanePopoutItemFolderInfo';

/**
 * Popout reading pane based on either itemId or InternetMessageId
 */
export default function popoutReadingPane(
    itemId?: string,
    internetMessageId?: string,
    mailboxInfo?: MailboxInfo,
    folderInfo?: ReadingPanePopoutItemFolderInfo
) {
    const route = getReadingPaneRouteForPopoutV2(
        mailboxInfo,
        itemId,
        null /*conversationId*/,
        internetMessageId
    );
    addPopoutV2('mail', route, folderInfo, {
        resizable: true,
    });
}
